import { Box, CircularProgress, Typography } from "@mui/material";
import PaymentHeader from "./PaymentHeader";
import { CustomContainer, PlanDetails, PlanHeader } from "./style";
import { NavigatePrevIcon, PaymentTickIcon } from "../../assets/Icons";
import { CustomButton } from "../../globalStyle";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { currentPlanSelector } from "../../store/account/selector";
import { useEffect } from "react";
import { AccountSagaActions } from "../../store/account/sagas";
import routeConstant from "../../utils/routeConstant";
import { useTheme } from "styled-components";
import { AdDrawerStyledButton } from "../commonComponents/adDetails/style";
import { PaymentSagaActions } from "../../store/payment/sagas";
import { getRedirectUrl } from "../../utils/redirect";
import {
  activeSubscriptionSelector,
  isButtonLoadingSelector,
  userCardDetailsSelector,
} from "../../store/payment/selector";
import { AccountReducerAction } from "../../store/account/slice";

const PreviewPage = () => {
  const { subscriptionId } = useParams();
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();

  const currentPlan = useSelector(currentPlanSelector);
  const isButtonloading = useSelector(isButtonLoadingSelector);
  const userCardDetails = useSelector(userCardDetailsSelector);
  const activePlan = useSelector(activeSubscriptionSelector);

  useEffect(() => {
    dispatch(PaymentSagaActions.getActiveSubscription());
  }, [dispatch]);

  const handleNavigate = (url: string) =>
    navigate(getRedirectUrl(url), { replace: true });

  useEffect(() => {
    dispatch(AccountSagaActions.getCurrentPlan({ id: subscriptionId }));

    return () => {
      dispatch(AccountReducerAction.setCurrentPlan({}));
    };
  }, [subscriptionId]);

  useEffect(() => {
    dispatch(PaymentSagaActions.GetUserCardDetails());
  }, [dispatch]);

  const handleDownGraderedPlan = () => {
    dispatch(
      PaymentSagaActions.getDownGradePlan({
        planId: subscriptionId,
        handleNavigate,
      })
    );
  };
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FFF",
        gap: "25px",
      }}
    >
      <PaymentHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "25px",
          maxWidth: "1100px",
          marginBottom: "30px",
        }}
      >
        <Box sx={{ display: "flex", width: "100%" }}>
          {currentPlan?._id && (
            <AdDrawerStyledButton onClick={() => navigate(-1)}>
              <NavigatePrevIcon />
              Back
            </AdDrawerStyledButton>
          )}
          <Typography
            style={{
              fontWeight: 700,
              fontSize: "32px",
              color: "#414042",
              textAlign: "center",
              flex: 1,
            }}
          >
            Cart
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap="30px">
          {!currentPlan?.name ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <CircularProgress size="50px" />
            </Box>
          ) : (
            <>
              <CustomContainer>
                <Box>
                  <PlanHeader>
                    <Box>
                      <Typography
                        variant="body1"
                        sx={{ fontSize: 24, fontWeight: 600 }}
                      >
                        {currentPlan?.name}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontSize: 16, fontWeight: 500 }}
                      >
                        {currentPlan?.description}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 32, fontWeight: 700 }}
                    >
                      ${currentPlan?.amount?.toFixed(2)}
                    </Typography>
                  </PlanHeader>
                  <PlanDetails>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        padding: "30px 30px 0",
                      }}
                    >
                      Plan Includes:{" "}
                    </Typography>
                    {currentPlan?.featureList?.map((perk: string) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          paddingX: "30px",
                        }}
                      >
                        <PaymentTickIcon />
                        <Box sx={{ fontSize: 16, fontWeight: 500 }}>{perk}</Box>
                      </Box>
                    ))}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        alignItems: "end",
                        gap: "20px",
                        borderTop: `1px solid ${theme.colors.border1}`,
                        padding: "30px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "end",
                          flexDirection: "column",
                          gap: "5px",
                        }}
                      >
                        {currentPlan?.deductionAmount ? (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                              textAlign: "right",
                            }}
                          >
                            {/* Plan Price */}
                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: 500,
                                color: "#414042",
                              }}
                            >
                              Plan Price: +$
                              {currentPlan?.amount?.toFixed(2) ?? "0.00"}
                            </Typography>

                            {/* Total Paid Amount (Per Seat × Count) */}
                            {currentPlan?.paidSeatCount ? (
                              <>
                                <Typography
                                  sx={{
                                    fontSize: "20px",
                                    fontWeight: 500,
                                    color: "#414042",
                                  }}
                                >
                                  Per Seat Amount: +$
                                  {currentPlan?.totalCurrentSeatAmount?.toFixed(
                                    2
                                  ) ?? "0.00"}{" "}
                                  × Paid Seat Count:{" "}
                                  {currentPlan?.paidSeatCount ?? 0} = Total Paid
                                  Amount: +$
                                  {(
                                    (currentPlan?.totalCurrentSeatAmount ?? 0) *
                                    (currentPlan?.paidSeatCount ?? 0)
                                  ).toFixed(2)}
                                </Typography>

                                {/* Unused Seat Balance */}
                                <Typography
                                  sx={{
                                    fontSize: "20px",
                                    fontWeight: 500,
                                    color: "#414042",
                                  }}
                                >
                                  Unused Seat Balance: -$
                                  {currentPlan?.refundTotal?.toFixed(2) ??
                                    "0.00"}
                                </Typography>
                              </>
                            ) : null}
                            {/* Remaining Balance Deduction */}
                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: 500,
                                color: "#414042",
                              }}
                            >
                              Remaining Balance Deduction: -$
                              {currentPlan?.deductionAmount?.toFixed(2) ??
                                "0.00"}
                            </Typography>

                            {/* Total Payable */}
                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#414042",
                              }}
                            >
                              Total Payable: $
                              {(
                                (currentPlan?.amount ?? 0) +
                                (currentPlan?.totalCurrentSeatAmount ?? 0) *
                                  (currentPlan?.paidSeatCount ?? 0) -
                                (currentPlan?.refundTotal ?? 0) -
                                (currentPlan?.deductionAmount ?? 0)
                              ).toFixed(2)}
                            </Typography>
                          </Box>
                        ) : (
                          <Typography
                            sx={{
                              fontSize: "20px",
                              fontWeight: 600,
                              color: "#414042",
                            }}
                          >
                            Total : ${currentPlan?.amount?.toFixed(2)}
                          </Typography>
                        )}
                        {activePlan?.activePlanDetails?.amount &&
                        activePlan?.planEndDate &&
                        activePlan?.activePlanDetails?.amount >
                          currentPlan?.amount ? (
                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontWeight: 500,
                              color: "#414042",
                            }}
                          >
                            Your current plan will continue until{" "}
                            {new Date(
                              activePlan?.planEndDate
                            ).toLocaleDateString("en-US", {
                              month: "2-digit",
                              day: "2-digit",
                              year: "numeric",
                            })}
                            , after which your subscription will be downgraded
                            as requested.
                          </Typography>
                        ) : null}
                      </Box>
                      {activePlan?.activePlanDetails?.amount &&
                      activePlan?.activePlanDetails?.amount >
                        currentPlan?.amount ? (
                        <CustomButton
                          style={{
                            fontSize: "16px",
                            color: "white",
                            borderRadius: "25px",
                            background:
                              "linear-gradient(94.04deg, #1c75bc 2.44%, #00aeef 112.73%)",
                            padding: "14px 30px",
                            height: "38px",
                          }}
                          onClick={handleDownGraderedPlan}
                          disabled={isButtonloading}
                        >
                          {isButtonloading && (
                            <CircularProgress
                              size={18}
                              color="inherit"
                              sx={{ marginRight: "4px" }}
                            />
                          )}
                          Confirm
                        </CustomButton>
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                          }}
                        >
                          <CustomButton
                            style={{
                              fontSize: "16px",
                              color: "white",
                              borderRadius: "25px",
                              background:
                                "linear-gradient(94.04deg, #1c75bc 2.44%, #00aeef 112.73%)",
                              padding: "14px 30px",
                              height: "38px",
                            }}
                            onClick={() =>
                              navigate(
                                `${routeConstant?.paymentCheckout}/dropin/${subscriptionId}`
                              )
                            }
                          >
                            Checkout with New Card
                          </CustomButton>
                          {userCardDetails?.length ? (
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                color: "white",
                                borderRadius: "25px",
                                background:
                                  "linear-gradient(94.04deg, #1c75bc 2.44%, #00aeef 112.73%)",
                                padding: "14px 30px",
                                height: "38px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                              onClick={() =>
                                navigate(routeConstant?.choosePaymentCard, {
                                  state: {
                                    subscriptionId,
                                    isSeatPurchase: false,
                                  },
                                })
                              }
                              disabled={isButtonloading}
                            >
                              {isButtonloading && (
                                <CircularProgress
                                  size={18}
                                  color="inherit"
                                  sx={{ marginRight: "4px" }}
                                />
                              )}
                              Checkout with Saved Card
                            </CustomButton>
                          ) : null}
                        </Box>
                      )}
                    </Box>
                  </PlanDetails>
                </Box>
              </CustomContainer>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PreviewPage;
